import React from 'react';
import { withRouter } from 'react-router-dom'
import { Col, Container, CardBody } from 'reactstrap';
import Table from '../tables/Table';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { signout } from '../../redux/actions/userActions';
import qs from 'qs';
import { GetControls } from '../../queries/controls'
//import slugify from 'slugify';

class ControlTable extends React.Component {
  constructor() {
    super();
    this._isMounted = false;
  }

  state = {
    controls: [],
    users: [],
    status: [],
    loadingControls: true,
    loadingStatus: true,
    loadedControls: false,
    loadedStatus: false,
    hasMore: null,
    nextToken: null,
    selectedControl: null,
    scrolledToBottom: false,
    paginationLoaded: false
  }

  componentDidMount() {
    try {
      this._isMounted = true
      if ((this.props.frameworkId && this.props.lowLevelCategory)) {
        if (!this.state.loadedControls) {
          this.getControls()
        }
      }
    } catch (e) {
      if (e.networkError) {
        if (e.networkError['statusCode'] === 401) {
          this.signoutUser()
        }
      } else {
        console.log(e.message)
        this.signoutUser()
      }
    }
    window.addEventListener("scroll", this.handleOnScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    //debugger
    try {
      this._isMounted = true
      if (prevProps !== this.props) {

        // if (!this.state.loadedControls) {
          this.getControls()
        // }
      }
    } catch (e) {
      if (e.networkError) {
        if (e.networkError['statusCode'] === 401) {
          this.signoutUser()
        }
      } else {
        console.log(e.message)
        this.signoutUser()
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    this._isMounted = false;
  }

  handleOnScroll = () => {
    var scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    var scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    var clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    var scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (scrolledToBottom && this.state.hasMore) {
      this.setState({
        scrolledToBottom: true,
        paginationLoaded: false,
        loadingControls: true,
        loadingStatus: true
      })
    }
  };

  getControls = async () => {
    const { data: controlData } = await this.props.client.query({
      query: GetControls(this.props.framework,
        this.props.lowLevelCategory,
        this.props.humanHighLevelCategory,
        this.props.isFlat,
        this.state.nextToken),
      fetchPolicy: 'network-only',
      variables: { token: null }
    })

    if (controlData && controlData.controls) {
      this.setState({
        controls: controlData.controls.items,
        loadedControls: true,
        loadingControls: false,
        nextToken: controlData.controls.nextToken,
        hasMore: controlData.controls.nextToken ? true : false,
        scrolledToBottom: false,
        paginationLoaded: true
      }, () => {
        try {
          const parsed = qs.parse(this.props.location.search.slice(1));
          if (parsed && parsed.controlId) {
            const id = String(parsed.controlId);

            const selectedControl = this.state.controls.find(c => c.controlID === id)

            if (selectedControl) {
              // this.getControlInView(selectedControl.controlID)
              this.setState({
                selectedControl: selectedControl.controlID
              })
            }
          }
        } catch (err) {
        }
      });
    } else {
      this.setState({ loadedControls: true, loadingControl: false });
    }
  }

  render() {
    return (
      <Container >
        <Col md={12} lg={12}>
          <div className=' card project-summary__statistics' style={{ float: 'left' }}>
            <CardBody className='dashboard-card'>
              <Table className='table--bordered table-hover' responsive striped>
                <thead>
                  <tr>
                    <th style={{
                      width: '10%'
                    }}>Control</th>
                    <th style={{
                      width: '90%'
                    }}>Control Advice</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.controls.map((c, i) => {
                    return <tr key={i} onClick={() => {
                      this.props.history.push({
                        pathname: `/app/editor/${this.props.match.params.frameworkName}/${this
                          .props.humanHighLevelCategory? this
                          .props.humanHighLevelCategory + '/' : ''}${require('base-64')
                            .encode(this.props.lowLevelCategory)}/${c.controlID}`,
                        state: {
                          framework: this.props.match.params.frameworkName,
                          lowLevelCategory: this.props.lowLevelCategory,
                          highLevelCategory: this.props.humanHighLevelCategory,
                          control: c
                        }
                      })
                    }}>
                      <td>{c.referenceID}</td>
                      <td>{c.advice ? c.advice : c.description}</td>
                    </tr>
                  })}
                </tbody>
              </Table>
            </CardBody>
          </div>
        </Col>
      </Container>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    users: state.controlsData.users,
    dataLoaded: !state.controlsData.loading,
    sidebar: state.sidebar
  }
}

export default connect(mapStateToProps, { signout })(withRouter(withApollo(ControlTable)));



// WEBPACK FOOTER //
// ./src/components/content_management/ControlTable.js